
import Vue from "vue";

interface AppFooterData {
	year: number;
}
export default Vue.extend({
	name: "AppFooter",
	props: {
		theme: String,
	},
	data(): AppFooterData {
		return {
			year: new Date().getFullYear(),
		};
	},
});
